import { Row } from 'reactstrap'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import FormTabNavigation from '../Common/FormTabNavigation'
import RecursiveForm from '../RecursiveForm'

const VirtualWalkVideoTab = ({
    subform,
    tabs,
    activeTab,
    activeMaterialsTab,
    materialsTabs,
    inputs,
    formik,
    handleTabChange,
    handleMaterialsTabChange,
}) => {
    return (
        <Row>
            <FormSideContainer />
            <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
                <FormTabNavigation
                    handleTabChange={handleMaterialsTabChange}
                    tabs={materialsTabs}
                    activeTab={activeMaterialsTab}
                    customClass="real-estate-form-subtabs mb-4"
                />
                <RecursiveForm inputs={inputs.mainForm} subform={subform} formik={formik} />
            </FormMainContainer>
        </Row>
    )
}

export default VirtualWalkVideoTab
